import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '../../../../shared/components/base/base.component';
import { FileType } from '../../../../shared/models/file-type';
import { ContentStoreService } from '../../../../core/services/content-store.service';
import { DrFileMeta, DrFileMetaCategoryList, FileUploadStatus } from '../../../../shared/models/dr-file';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { Role } from '@app/core/authentication/permission';
import * as _ from 'lodash-es';
import { CaseFileCategories } from '@app/shared/models/case-file-category';


@Component({
  selector: 'case-files-upload',
  templateUrl: './case-files-upload.component.html',
  styleUrls: ['./case-files-upload.component.scss']
})
export class CaseFilesUploadComponent extends BaseComponent implements OnInit {

  @Input()
  private caseId: string;

  @Input()
  public smpFileCategory?: CaseFileCategories;

  @Input()
  private role?: Role;

  @Input()
  public dropzoneLabel?: string;

  @Input()
  public addButtonLabel?: string;

  @Input()
  public acceptedFiles: FileType[];

  @Input()
  public hasContent: boolean;

  @Input()
  public fileMetaCategoryList: DrFileMetaCategoryList;

  @Output()
  public fileMetaCategoryListChange = new EventEmitter<DrFileMetaCategoryList>();


  constructor(protected contentStoreService: ContentStoreService, protected fileUtilityService: FileUtilityService) {
    super();
  }

  public ngOnInit() {
  }

  public onFilesSelected(files: File[]): void {
    if (files) {
      _.each(files, (file: File) => {
        const newFileMeta = new DrFileMeta();
        newFileMeta.filename = file.name;
        newFileMeta.document_type = this.smpFileCategory;
        newFileMeta.creator_role = this.role;
        newFileMeta.status = FileUploadStatus.LOADING;
        newFileMeta.order = this.fileMetaCategoryList.getNextOrderForCategory(this.smpFileCategory);
        this.fileMetaCategoryList.addFileMeta(newFileMeta);
        this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);

        this.fileUtilityService.fileAsBinaryString(file)
                               .subscribe((fileAsBinaryString) => {
              this.contentStoreService.addCaseFile(this.caseId, fileAsBinaryString, newFileMeta)
                                      .subscribe((result: DrFileMeta) => {
                      result.status = FileUploadStatus.READY;
                      this.fileMetaCategoryList.replaceFileMetaAfterUpload(result);
                      this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);
                  },
                    err => {
                      newFileMeta.status = FileUploadStatus.ERROR;
                      this.fileMetaCategoryList.replaceFileMetaAfterUpload(newFileMeta);
                      this.fileMetaCategoryListChange.emit(this.fileMetaCategoryList);
                    }
                  );
            });
      });
    }
  }
}
